import { render, staticRenderFns } from "./SlugPublicInfo.vue?vue&type=template&id=6fc89979&"
import script from "./SlugPublicInfo.vue?vue&type=script&lang=js&"
export * from "./SlugPublicInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports